<template>
    <div id="create-registration-type" class="row">
        <div class="col-12">
            <card>
                <template slot="header">
                    <span v-if="$route.name === 'registration-type-create'">Create registration type</span>
                    <span v-else>Edit registration type</span>
                </template>

                <tabs type="primary">
                    <tab-pane label="General Information">
                        <el-form label-width="20%" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                            <el-form-item label="Name*">
                                <el-input v-model="registrationType.name"/>
                            </el-form-item>
                            <el-form-item label="Description">
                                <Editor v-model="registrationType.description"/>
                            </el-form-item>
                            <el-form-item label="Price*">
                                <el-input v-model="registrationType.price" type="number" :min="0"/>
                            </el-form-item>
                            <el-form-item label="Discount">
                                <el-checkbox v-model="registrationType.discount">
                                    Has discount?
                                </el-checkbox>
                            </el-form-item>
                            <el-form-item v-if="registrationType.discount" label="Discount Type" label-width="30%">
                                <el-radio v-if="registrationType.discount" v-model="registrationType.discountType" label="amount">Amount</el-radio>
                                <el-radio v-if="registrationType.discount" v-model="registrationType.discountType" label="percent">Percent</el-radio>
                            </el-form-item>
                            <el-form-item v-if="registrationType.discount" label="Discount Period?" label-width="30%">
                                <el-radio v-if="registrationType.discount" v-model="registrationType.discountPeriod" :label="true" @change="isPeriod(true)">Yes</el-radio>
                                <el-radio v-if="registrationType.discount" v-model="registrationType.discountPeriod" :label="false" @change="isPeriod(false)">No</el-radio>
                            </el-form-item>
                            <div class="fees-discount-block">
                              <div v-for="(item, index) in discountPeriodSet" class="discount-container">
                                  <el-form-item v-if="registrationType.discountPeriod==true && registrationType.discount" label="Start Date" label-width="30%">
                                      <el-date-picker v-model="registrationType.discountStartDate[index]" type="datetime"/>
                                  </el-form-item>
                                  <el-form-item v-if="registrationType.discountPeriod==true && registrationType.discount" label="End Date" label-width="30%">
                                      <el-date-picker v-model="registrationType.discountEndDate[index]" type="datetime"/>
                                  </el-form-item>
                                  <el-form-item v-if="registrationType.discount" label="Discount Value"  label-width="30%">
                                      <el-input v-model="registrationType.discountValue[index]" type="number" :min="0"/>
                                  </el-form-item>
                                  <el-input v-model="registrationType.discountIds[index]" type="hidden"/>
                                  <el-form-item class="border-bottom" />
                              </div>
                            </div>

                            <el-form-item v-if="registrationType.discountPeriod==true && registrationType.discount" label-width="30%">
                                <el-button
                                    type="primary"
                                    class="btn btn-primary"
                                    @click="addPeriod()">
                                        Add Period
                                </el-button>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.guestRegistrationOnly">
                                    Only allow guest registration
                                </el-checkbox>
                                <p>Enable this option if you want to limit the registration only to the people present on the guest list. Very useful for private events</p>
                                <el-input
                                    v-if="registrationType.guestRegistrationOnly"
                                    v-model="registrationType.allowedEmails"
                                    type="textarea"/>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.publicRegistration">
                                    Allow public registration
                                </el-checkbox>
                                <p>Select this option to allow this participant type to be available for registration online, if you do not select it this participant type will only be available for registration in your administrator space. This can be useful for VIPs or press for example</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.allowEdit">
                                    Allow participant to edit their registration data in the event page
                                </el-checkbox>
                                <p>Select this option if you want to allow participants to modify their registration information</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.requireValidation">
                                    Require validation after registration
                                </el-checkbox>
                                <p>Select this option if you wish to validate participants before they receive their confirmation email</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.blockChanges">
                                    Block changes that induce reimbursements for attendees. (Workshops, Business Conferences, Merchandising)
                                </el-checkbox>
                                <p>Select this option if you want to block all modifications that would reduce the amount paid by the attendees and which would require a reimbursment</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.registrationWithoutPayment">
                                    Allow registration without payment
                                </el-checkbox>
                                <p>Select this option if you want to accept off-line payments. Participants can finish the registrations and they pay off-line by transfer or cheque.</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.discounCoupons">
                                    Enable use of discount coupons
                                </el-checkbox>
                                <p>Select this option to enable the use of discount coupons for this kind of participant type</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.badgePrintingWithoutPayment">
                                    Allow badge printing without payment
                                </el-checkbox>
                                <p>Select this option if you want to allow participant to print their badges even if they have not paid</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.showPaymentStatus">
                                    Show payment status on registration form
                                </el-checkbox>
                                <p>Select this option if you want to show the payment status at the bottom of the registration form</p>
                            </el-form-item>
                            <el-form-item label="">
                                <el-checkbox v-model="registrationType.typeGroupOnly">
                                    Available only as type group child
                                </el-checkbox>
                                <!-- <p>Select this option if you want to show the payment status at the bottom of the registration form</p> -->
                            </el-form-item>
                        </el-form>
                    </tab-pane>
                    <tab-pane label="Registration Form">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Add <router-link :to="{ name: 'custom-fields' }">custom fields</router-link> for registration form</span>
                            <el-button
                                @click="chooseCustomFields = true"
                                type="primary"
                                class="btn btn-primary">
                                    New
                            </el-button>
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item font-weight-bold">
                                <div class="row">
                                    <div class="col-3">Title</div>
                                    <div class="col-3">Name</div>
                                    <div class="col-3">Type</div>
                                    <div class="col-3">Actions</div>
                                </div>
                            </li>
                            <draggable v-model="registrationType.fields">
                                <transition-group>
                                    <li
                                        v-for="field in registrationType.fields"
                                        :key="`field-${field._id}`"
                                        class="list-group-item cursor-pointer">
                                            <div class="row">
                                                <div class="col-3">
                                                    <fa icon="bars" class="mr-2"/>
                                                    {{ field.title }}
                                                </div>
                                                <div class="col-3">{{ field.name }}</div>
                                                <div class="col-3">{{ field.type }}</div>
                                                <div class="col-3">
                                                    <el-button
                                                        size="mini"
                                                        class="btn m-0 mr-2"
                                                        @click="editField(field)">
                                                            <fa :icon="['fas', 'pen']"/>
                                                    </el-button>
                                                    <el-button
                                                        size="mini"
                                                        class="btn btn-danger m-0"
                                                        @click="removeField(field._id)">
                                                            <fa :icon="['fas', 'trash']"/>
                                                    </el-button>
                                                </div>
                                            </div>
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </tab-pane>
                    <tab-pane label="Enhanced Validations">

                        <div class="d-flex justify-content-end">
                            <el-button @click="openValidationFormDialog" type="primary" class="btn btn-primary">
                                New
                            </el-button>
                        </div>

                        <el-table :data="validations">
                            <el-table-column label="Active">
                                <template slot-scope="props">
                                    <el-checkbox @change="onValidationSelectionChange(props.row)" v-model="props.row.active"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="Name" prop="name" min-width="200px">
                            </el-table-column>
                            <el-table-column label="Actions" min-width="300px">
                                <template slot-scope="props">
                                    <el-tooltip v-if="user.admin" content="Edit" placement="top">
                                        <el-button
                                            @click="editValidation(props.row)"
                                            class="btn"
                                            title="Edit"
                                        >
                                            <fa :icon="['fas', 'pen']" />
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip content="Delete" placement="top">
                                        <el-button
                                            @click="deleteValidation(props.row)"
                                            class="btn btn-danger ml-1"
                                            title="Delete"
                                        >
                                            <fa :icon="['fas', 'trash']" />
                                        </el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </tab-pane>
                    <tab-pane label="Badge">
                        <h5>Badge Design</h5>
                        <p>Here you can design and customize attendee badges. You can create e-badges that can be sent directly to users and printed on deskjet printers or print personalized stickers on site with thermal printers.</p>
                        <el-radio v-model="registrationType.printerType" label="deskjet">Deskjet</el-radio>
                        <el-radio v-model="registrationType.printerType" label="thermal">Thermal</el-radio>
                        <quill-editor v-model="registrationType.badgeContent" class="mt-3 mb-3"/>
                        <el-checkbox v-model="registrationType.printInCapitalLetters">
                            Print badges in capital letters
                        </el-checkbox>
                        <p>The following tags allow you to personalize your communication with attendees. Add them to your text to reuse the information you have collected in the registration form for each participant.</p>
                        <ul>
                            <li
                                v-for="field in registrationType.fields"
                                :key="`field-description-${field._id}`">
                                    Use {{ '${' + field.name + '}' }} to get attendee {{ field.title }}
                            </li>
                        </ul>
                    </tab-pane>
                    <tab-pane label="Messages">
                        <p>This is the email message that will be sent to your participants once their registration has been validated. We have initiated it for you, but you can customize it to your own needs.</p>
                        <el-checkbox v-model="registrationType.sendEmailOnRegistration">Send welcome email upon registration</el-checkbox><br/>
                        <el-checkbox v-model="registrationType.includeInvitationFile">Include invitation file</el-checkbox>
                        <el-form label-position="top">
                            <el-form-item label="Subject">
                                <el-input v-model="registrationType.emailSubject"/>
                            </el-form-item>
                        </el-form>
                        <quill-editor v-model="registrationType.welcomeEmail" id="welcome-email"/>
                        <ul class="mt-5">
                            <li>Use ${confirmation_number} to get attendee Confirmation Number</li>
                            <li
                            v-for="field in registrationType.fields"
                            :key="`field-description-${field._id}`">
                            Use {{ '${' + field.name + '}' }} to get attendee {{ field.title }}
                            </li>
                            <li>Use ${allregistrants.fieldname} to get all info for all registrants</li>

                        </ul>
                    </tab-pane>
                    <tab-pane label="Group Registration">
                        <div>
                            <label for="minimum-count">MINIMUM COUNT</label>
                            <el-input v-model="registrationType.minimumCount" class="mt-2" id="minimum-count" type="number" :min="0"/>
                        </div>
                        <label class="mt-4" for="select-types">TYPES</label>
                        <el-table id="select-types" :data="Object.values(types)">
                                <el-table-column label="Name" prop="name"/>
                                <el-table-column label="Included">
                                    <template slot-scope="props">
                                        <el-checkbox v-model="props.row.included"/>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Count">
                                    <template slot-scope="props">
                                        <el-input type="number" v-model="props.row.count" :min="0"/>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Order">
                                    <template slot-scope="props">
                                        <el-input type="number" v-model="props.row.order" :min="0"/>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Prevent External Creation">
                                    <template slot-scope="props">
                                        <el-checkbox v-model="props.row.hidden"/>
                                    </template>
                                </el-table-column>
                        </el-table>
                    </tab-pane>
                </tabs>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary"
                            class="btn btn-primary"
                            @click="submit()"
                            :loading="saving">
                                Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>

        <el-dialog
            :visible.sync="chooseCustomFields"
            title="Choose custom fields">
                <el-table
                    ref="customFieldsTable"
                    :data="addableFields"
                    @selection-change="onFieldSelect">
                        <el-table-column
                            type="selection"
                            width="55"/>
                        <el-table-column label="Title" prop="title"/>
                        <el-table-column label="Name" prop="name"/>
                        <el-table-column label="Type" prop="type"/>
                </el-table>
        </el-dialog>

        <el-dialog :visible.sync="showEditField">
            <el-form label-width="300px">
                <el-form-item label="Name">
                    <el-input v-model="editableField.name" disabled/>
                </el-form-item>
                <el-form-item label="Title">
                    <el-input v-model="editableField.title" disabled/>
                </el-form-item>
                <el-form-item label="Locked">
                    <el-radio-group v-model="editableField.locked">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Required">
                    <el-radio-group v-model="editableField.required">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Registrant Editable">
                    <el-radio-group v-model="editableField.registrantEditable">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Registrant Editable during Edit Registration (Existing Registrant)">
                    <el-radio-group v-model="editableField.registrantEditableDuringRegistration">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Registrant Editable during Edit Registration (New Registrant)">
                    <el-radio-group v-model="editableField.registrantEditableDuringRegistrationNewRegistrant">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Show on Registration Screen">
                    <el-radio-group v-model="editableField.showOnRegistrationScreen">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="editableField.type === 'list' || editableField.type === 'radio'"
                    label="Fee Field">
                        <el-radio-group v-model="editableField.feeField">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="editableField.feeField"
                    label="Fee Values">
                        <el-input
                            v-model="editableField.feeValues"
                            type="textarea"
                            rows="5"/>
                </el-form-item>

                <el-form-item
                    v-if="editableField.feeField"
                    label="Discount">
                        <el-checkbox v-model="editableField.discount">
                                Has discount?
                            </el-checkbox>
                </el-form-item>
                <el-form-item v-if="editableField.discount" label="Discount Type" label-width="30%">
                    <el-radio v-if="editableField.discount" v-model="editableField.discountType" label="amount">Amount</el-radio>
                    <el-radio v-if="editableField.discount" v-model="editableField.discountType" label="percent">Percent</el-radio>
                </el-form-item>
                <el-form-item v-if="editableField.discount" label="Discount Period?" label-width="30%">
                    <el-radio v-if="editableField.discount" v-model="editableField.discountPeriod" :label="true" @change="isPeriod2(true)">Yes</el-radio>
                    <el-radio v-if="editableField.discount" v-model="editableField.discountPeriod" :label="false" @change="isPeriod2(false)">No</el-radio>
                </el-form-item>
                <div class="fees-discount-block">
                  <div v-for="(item, index) in discountPeriodSet2" class="discount-container">
                      <el-form-item v-if="editableField.discountPeriod==true && editableField.discount" label="Start Date" label-width="30%">
                          <el-date-picker v-model="editableField.discountStartDate[index]" type="datetime"/>
                      </el-form-item>
                      <el-form-item v-if="editableField.discountPeriod==true && editableField.discount" label="End Date" label-width="30%">
                          <el-date-picker v-model="editableField.discountEndDate[index]" type="datetime"/>
                      </el-form-item>
                      <el-form-item v-if="editableField.discount" label="Discount Value"  label-width="30%">
                          <el-input v-model="editableField.discountValue[index]" type="textarea"
                            rows="5"/>
                      </el-form-item>
                      <el-form-item class="border-bottom" />
                  </div>
                </div>
                <el-form-item v-if="editableField.discountPeriod==true && editableField.discount" label-width="30%">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        @click="addPeriod2()">
                            Add Period
                    </el-button>
                </el-form-item>
                        
                <el-form-item
                    v-if="editableField.feeField"
                    label="Fee Formula">
                        <el-input v-model="editableField.feeFormula"/>
                </el-form-item>
                <el-form-item
                    v-if="['checkboxes', 'list', 'radio'].includes(editableField.type)"
                    label="Labels">
                        <el-input
                            v-model="editableField.labels"
                            type="textarea"
                            rows="5"/>
                </el-form-item>
                <el-form-item
                    v-if="['checkboxes', 'list', 'radio'].includes(editableField.type)"
                    label="Values">
                        <el-input
                            v-model="editableField.values"
                            type="textarea"
                            rows="5"/>
                </el-form-item>
                <el-form-item
                    v-if="['color', 'integer', 'radio', 'text', 'textarea', 'calendar'].includes(editableField.type) || (editableField.type === 'list' && editableField.multiple === false)"
                    label="Default Value">
                        <el-input
                            v-if="editableField.type === 'textarea'"
                            v-model="editableField.defaultValue"
                            type="textarea"
                            rows="5"/>
                        <el-input
                            v-else-if="editableField.type === 'integer'"
                            v-model="editableField.defaultValue"
                            type="number"/>
                        <el-date-picker
                            v-else-if="editableField.type === 'calendar'"
                            v-model="editableField.defaultValue"
                            placeholder="Choose Date"></el-date-picker>
                        <el-input
                            v-else
                            v-model="editableField.defaultValue"/>
                </el-form-item>
                <el-form-item
                    v-if="editableField.type === 'checkboxes' || (editableField.type === 'list' && editableField.multiple === true)"
                    label="Default Values">
                        <el-input
                            v-model="editableField.defaultValue"
                            type="textarea"
                            rows="5"/>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <div class="d-flex justify-content-end">
                    <el-button
                        class="btn btn-primary"
                        @click="showEditField = false">
                            Save
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog width="70%" v-if="validationFormDialogOpen" :visible.sync="validationFormDialogOpen" title="Add New Validation">
            <ValidationForm @close="validationFormDialogOpen = false" :allFields="getAllFields" :mode="mode" :data="validationToEdit" @data="handleData" />
        </el-dialog>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http'
import draggable from 'vuedraggable'
import swal from 'sweetalert2'
import ValidationForm from '../../components/Validations/ValidationForm.vue'
import Editor from '../../components/Editor.vue'

export default {
    components: {
        draggable,
        ValidationForm,
        Editor
    },
    computed: {
        ...mapState([
            'fields',
            'user'
        ]),
        getAllFields(){
            return this.registrationType.fields
        }
    },
    watch:{
        editableField:{
            deep: true,
            handler: function(e) {
              //console.log('test', this.editableField._id, this.editableField, this.registrationType)
              //this.editableField.discount = this.editableField.discount;
              let updatedFieldIndex = this.registrationType.fields.findIndex(field=>field._id===this.editableField._id)
              this.registrationType.fields[updatedFieldIndex] = this.editableField
            }
        }
    },
    data () {
        return {
            registrationType: {
                minimumCount: null,
                eventId: this.$route.params.eventId,
                name: '',
                price: 0,
                discount: false,
                discountType: 'amount',
                discountValue: [],
                discountPeriod: false,
                discountStartDate: [],
                discountEndDate: [],
                discountIds: [],
                guestRegistrationOnly: false,
                allowedEmails: '',
                publicRegistration: false,
                allowEdit: false,
                requireValidation: false,
                blockChanges: false,
                registrationWithoutPayment: false,
                discounCoupons: false,
                badgePrintingWithoutPayment: false,
                showPaymentStatus: false,
                typeGroupOnly: false,
                fields: [],
                printerType: 'deskjet',
                badgeContent: '',
                printInCapitalLetters: false,
                welcomeEmail: '',
                sendEmailOnRegistration: false,
                includeInvitationFile: false,
                emailSubject: '',
                typeGroups: [],
            },
            chooseCustomFields: false,
            showEditField: false,
            editableField: {
                discount: false,
            },
            saving: false,
            loading: false,
            types: {},
            addableFields: [],
            discountPeriodSet: 1,
            discountPeriodSet2: 1,
            customFieldsDiscounts: [],
            validationFormDialogOpen: false,
            validations: [],
            mode: "create",
            validationToEdit: null,
            activeValidationIds: [],
        }
    },
    async mounted () {
        this.getData()
        this.validations = (await http.get(`/api/enhanced-validations/${this.$route.params.eventId}?type=${this.$route.params.typeId}`)).data.validations
        this.validations.map(val=>{
            if(val.active && val._id) this.activeValidationIds.push(val._id)
        })
    },
    methods: {
        editValidation(validation){
            this.mode = "edit"
            this.validationToEdit = validation
            this.validationFormDialogOpen = true
        },
        async deleteValidation(validation){
            let { value: confirmed } = await swal({
                title: `Are you sure you want to delete the validation?`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-default btn-fill'
            })
            if(!confirmed) return
            try {
                const res = await http.delete(`/api/enhanced-validations/${validation._id}`)
                this.validations = this.validations.filter(val => val._id !== validation._id)
                this.$notify(res.data.message)
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data.message
                })
            }
        },
        openValidationFormDialog(){
            this.mode = "create"
            this.validationToEdit = null
            this.validationFormDialogOpen = true
        },
        async handleData(data, message, name){

            if(!message || !name){
                this.$notify({
                    type: 'danger',
                    message: `${!message ? 'message' : 'name'} field is required`
                })

                return
            }
            
            if(this.mode == "edit"){
                this.validations.forEach(val =>{
                    if(val._id == this.validationToEdit._id){
                        console.log(val.rules);
                        val.rules = [...data];
                        val.message = message
                        val.name = name
                    }
                })

                try {
                    const res = await http.patch(`/api/enhanced-validations/${this.validationToEdit._id}`, {
                        rules: data,
                        message,
                        name
                    })
                    this.validationFormDialogOpen = false
                    this.$notify(res.data.message)
                    
                } catch (error) {
                    this.$notify({
                        type: 'danger',
                        message: error.response.data.message
                    })
                }

                
            }else{
                try {
                    const res = await http.post(`/api/enhanced-validations`, {
                        event: this.$route.params.eventId,
                        type: this.$route.params.typeId,
                        message,
                        rules: data,
                        name
                    })
    
                    this.validations = [res.data.validation, ...this.validations]
                    this.activeValidationIds.push(res.data.validation._id)
                    this.validationFormDialogOpen = false
                    this.$notify(res.data.message)
                    
                } catch (error) {
                    this.$notify({
                        type: 'danger',
                        message: error.response.data.message
                    })
                }
            }


        },
        async onValidationSelectionChange(row){
            if(row.active){
                this.activeValidationIds.push(row._id)
            }else{
                this.activeValidationIds = this.activeValidationIds.filter(id => id != row._id)
            }
        },
        getData: async function () {
            this.loading = true
            try {
                if (this.$route.params.typeId) {
                    const response = await this.$store.dispatch('get', { path: 'types', key: 'type', id: this.$route.params.typeId })
                    let discount_obj = response.data.discount?[...response.data.discount]:[]
                    
                    let discount = discount_obj.length?true:false;
                    this.discountPeriodSet = discount_obj.length==0?1:discount_obj.length;
                    let discountValue = []
                    let discountStartDate = []
                    let discountEndDate = []
                    let discountIds = []
                    let discountType = 'amount';
                    let discountPeriod = false;
                    if(discount_obj.length){
                        discountType = discount_obj[0].discountType;
                        discountPeriod = Boolean(discount_obj[0].discountPeriod)
                        discount_obj.map(e=>{
                            discountValue.push(e.discountValue)
                            discountStartDate.push(e.discountStartDate)
                            discountEndDate.push(e.discountEndDate)
                            discountIds.push(e._id)
                        })
                    }
                    this.registrationType = {
                        discount,
                        discountType,
                        discountPeriod,
                        discountValue,
                        discountStartDate,
                        discountEndDate,
                        discountIds,
                        ...response.data.type
                    }
                }

                const [fieldsResponse, typesResponse] = await Promise.all([
                    this.$store.dispatch('getAll', { path: 'fields', params: { filters: { eventId: this.$route.params.eventId } } }),
                    this.$store.dispatch('getAll', { path: 'types', params: { filters: { eventId: this.$route.params.eventId } } })
                ])

                typesResponse.data.types.forEach(type => {
                    let newType = {...type}
                    newType.count = 0
                    newType.included = false
                    newType.hidden = false
                    newType.order = 0

                    const existingCount = this.registrationType.groupCount ? this.registrationType.groupCount[newType._id] : null
                    const existingOrder = this.registrationType.orderGroup ? this.registrationType.orderGroup[newType._id] : null
                    if (existingCount) {
                        newType.count = existingCount
                        newType.order = existingOrder
                    }

                    const included = this.registrationType.groups.find(g => g._id === newType._id)
                    if (included) {
                        newType.included = true
                    }

                    const hidden = this.registrationType.hiddenFromExternal.find(tid => tid === newType._id)
                    if (hidden) {
                        newType.hidden = true
                    }

                    this.$set(this.types, type._id, newType)
                })

                this.updateAvailableFields()
            } catch (e) {
                console.log(e)
                console.log('error loading data')
            }
            this.loading = false
        },
        onFieldSelect: function (fields) {
            fields.forEach(field => {
                this.registrationType.fields.push(field)
            })
            this.updateAvailableFields()
        },
        removeField: function (id) {
            this.registrationType.fields = this.registrationType.fields.filter(field => field._id !== id)
            this.updateAvailableFields()
        },
        updateAvailableFields: function () {
            const addedFields = this.registrationType.fields.map(field => field._id)
            this.addableFields = this.fields.filter(field => !addedFields.includes(field._id))
        },
        editField: async function (field) {//console.log('@@field', field, this.$router.currentRoute.params.typeId)
            this.showEditField = true
            
            let fieldDiscount = await http.post(`/api/discount-filter`, {data:{field:field._id, type:this.$router.currentRoute.params.typeId}, rawData:true})
            let discount_obj = fieldDiscount.data?[...fieldDiscount.data]:[]
            let discount = discount_obj.length?true:false;
            this.discountPeriodSet2 = discount_obj.length==0?1:discount_obj.length;
            let discountValue = []
            let discountStartDate = []
            let discountEndDate = []
            let discountType = 'amount';
            let discountPeriod = false;
            if(discount_obj.length){
                discountType = discount_obj[0].discountType;
                discountPeriod = Boolean(discount_obj[0].discountPeriod)
                discount_obj.map(e=>{
                    discountValue.push(e.discountValue)
                    discountStartDate.push(e.discountStartDate)
                    discountEndDate.push(e.discountEndDate)
                })
            }
            this.editableField = {
                ...field,
                discount,
                discountType,
                discountPeriod,
                discountValue,
                discountStartDate,
                discountEndDate,
            }
            this.customFieldsDiscounts.push({
                field:field._id, 
                type:this.$router.currentRoute.params.typeId,
                discount: this.editableField.discount,
                discountType: this.editableField.discountType,
                discountPeriod: this.editableField.discountPeriod,
                discountValue,
                discountStartDate,
                discountEndDate,
            })
        },
        selectGroups: function (groups) {
            this.registrationType.groups = groups
        },
        submit: async function () {
            if(this.editableField.discount){
                this.customFieldsDiscounts.map(_discount=>{
                    _discount.discount = this.editableField.discount
                    _discount.discountType = this.editableField.discountType
                    _discount.discountPeriod = this.editableField.discountPeriod
                })
            }else{
                this.customFieldsDiscounts = [{field:this.editableField._id, type:this.registrationType._id, discountValue:[]}];
            }
            let data = {...this.registrationType, customFieldsDiscounts:this.customFieldsDiscounts}
            data.groups = []
            data.hiddenFromExternal = []
            Object.values(this.types).forEach(type => {
                if(type.hidden) data.hiddenFromExternal.push(type)
                if (!type.included) {
                    return
                }
                data.groups.push(type)
                if (data.groupCount) {
                    data.groupCount[type._id] = type.count
                    if(!data.orderGroup) 
                        data.orderGroup = {}
                    data.orderGroup[type._id] = type.order
                } else {
                    data.groupCount = {
                        [type._id]: type.count
                    }
                    data.orderGroup = {
                        [type._id]: type.order
                    }
                }
            })

            try {
                this.saving = true
                if (this.$route.params.typeId) {
                    const response = await this.$store.dispatch('update', {
                        path: 'types',
                        data,
                        id: this.$route.params.typeId
                    })
                    //console.log(response.data)

                    this.$notify('Information successfully updated!')
                    this.getData()
                } else {
                    await this.$store.dispatch('create', { path: 'types', data })
                    this.$notify('Registration type was successfully created!')
                    this.$router.push({ name: 'registration-types' })
                }
            } catch (e) {
                console.log('error creating new registration type')
            }



            try {
                const res = await http.patch(`/api/enhanced-validations/${this.$route.params.eventId}/${this.$route.params.typeId}`,{
                    activeIds: this.activeValidationIds
                });
                // this.$notify(res.data.message)
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data.message
                })
            }
            this.saving = false
        },
        addPeriod: function(){
            this.discountPeriodSet++;
        },
        isPeriod:function(value){
            if(!value)
                this.discountPeriodSet = 1
        },
        addPeriod2: function(){
            this.discountPeriodSet2++;
        },
        isPeriod2:function(value){
            if(!value)
                this.discountPeriodSet2 = 1
        }
    }
};
</script>

<style scoped>

.validations-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 10px;
}

.validations-container-inner{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
}

.validation-field-container{
    display: flex;
}

.validation-field{
    text-align: center;
    height: 150px;
    width: 200px;
    margin: 0;
    border: 1px solid #ccc;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    gap:5px;

}

.edit-or-delete-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 20px;
}

.nbtn{
    background: none;
    border: none;
}

.nbtn:hover{
    text-decoration: underline;
}
.nbtn.nbtn-danger:hover{
    color: red;
}
.nbtn.nbtn-warnign:hover{
    color: rgb(0, 136, 255);
}

.validation-field:hover .edit-or-delete-container,
.validation-field p:hover .edit-or-delete-container{
    display: flex;
}

.btn-circle{
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.and-or-container{
    border: 1px solid #9f9f9f;
    border-radius: 3px;
    width: max-content;
}

.and-btn,
.or-btn{
    background: #fff;
    border: none;
    display: inline-block;
    width: 50px;
    padding: 5px;
}

.and-btn:hover, 
.or-btn:hover{
    background: #dddddd;
}


.and-btn.active-btn{
    background: #388e3c;
    color: white;
}
.or-btn.active-btn{
    background: #388e3c;
    color: white;
}
</style>
